<template>
    <Register class="container" :user="getCurrentUser()" title="Profile" buttonLabel="Save" @cancelOnClick="cancelOnClick"
        mode="edit" />
</template>

<script>
import Register from '@/components/login module/Register.vue'

export default {
    name: 'EditUserView',
    components: {
        Register,
    },
    methods: {
        cancelOnClick() {
            this.$router.replace({ path: '/' });
        },
        getCurrentUser() {
            return { ...this.$store.getters.currentUser };
        }
    }
}
</script>

<style scope>
.container {
    position: absolute;
    transform: translate(-50%, -70%);
    top: 50vh;
    left: 50vw;
}
</style>